import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _InternationalPaymentsFilledIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M1.55671 10.7376C1.25939 10.7376 1.0269 10.4792 1.07281 10.1854C1.70072 6.1675 4.37924 2.8534 7.9711 1.41104C8.39592 1.24045 8.75577 1.71346 8.53148 2.11254C7.1284 4.60909 6.24618 7.39024 5.95439 10.2774C5.92816 10.5369 5.71178 10.7376 5.45091 10.7376H1.55671Z"
        fill={iconColor}
      />
      <Path
        d="M18.5491 10.7376C18.2882 10.7376 18.0718 10.5369 18.0456 10.2774C17.7538 7.39024 16.8716 4.60909 15.4685 2.11254C15.2442 1.71346 15.6041 1.24045 16.0289 1.41104C19.6208 2.8534 22.2993 6.1675 22.9272 10.1854C22.9731 10.4792 22.7406 10.7376 22.4433 10.7376H18.5491Z"
        fill={iconColor}
      />
      <Path
        d="M11.6127 1.53675C11.8012 1.26367 12.1988 1.26367 12.3873 1.53675C14.1084 4.03082 15.2009 7.156 15.5615 10.1936C15.5962 10.4854 15.3651 10.7376 15.0713 10.7376H8.92874C8.63488 10.7376 8.40383 10.4854 8.43847 10.1936C8.79907 7.156 9.89161 4.03082 11.6127 1.53675Z"
        fill={iconColor}
      />
      <Path
        d="M11.6127 22.4642C11.8012 22.7373 12.1988 22.7373 12.3873 22.4642C14.1084 19.9702 15.2009 16.845 15.5615 13.8074C15.5962 13.5156 15.3651 13.2634 15.0713 13.2634H8.92874C8.63488 13.2634 8.40383 13.5156 8.43847 13.8074C8.79907 16.845 9.89161 19.9702 11.6127 22.4642Z"
        fill={iconColor}
      />
      <Path
        d="M1.07281 13.8156C1.0269 13.5218 1.25939 13.2634 1.55671 13.2634H5.45091C5.71178 13.2634 5.92816 13.4641 5.95439 13.7236C6.24618 16.6107 7.1284 19.3919 8.53148 21.8884C8.75577 22.2875 8.39592 22.7605 7.9711 22.5899C4.37924 21.1476 1.70072 17.8335 1.07281 13.8156Z"
        fill={iconColor}
      />
      <Path
        d="M18.5491 13.2634C18.2882 13.2634 18.0718 13.4641 18.0456 13.7236C17.7538 16.6107 16.8716 19.3919 15.4685 21.8884C15.2442 22.2875 15.6041 22.7605 16.0289 22.5899C19.6208 21.1476 22.2993 17.8335 22.9272 13.8156C22.9731 13.5218 22.7406 13.2634 22.4433 13.2634H18.5491Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const InternationalPaymentsFilledIcon = assignWithoutSideEffects(_InternationalPaymentsFilledIcon, {
  componentId: 'InternationalPaymentsFilledIcon',
});

export default InternationalPaymentsFilledIcon;
